// removed by extract-text-webpack-plugin
module.exports = {"root":"CentricUI__content-panels__C8FlexLayoutTab__root","inject":"CentricUI__content-panels__C8FlexLayoutTab__inject","iframe":"CentricUI__content-panels__C8FlexLayoutTab__iframe"};


//////////////////
// WEBPACK FOOTER
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/C8FlexLayoutTab.css
// module id = 1120
// module chunks = 10